import { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { Portal } from '@elfsight/widget-modal';
import { useSettings } from '@wu/widget-core';
import { useA11yState } from '../hooks/use-a11y-state';
import { useDemoToggle } from '../hooks/use-demo-toggle';

const LINE_SIZE_PX = 150;

export function ReadingMask() {
  const { editMode } = useSettings();
  const { toggleState } = useDemoToggle();
  const { a11yState: { readingMask } = {} } = useA11yState();
  const [mouseY, setMouseY] = useState(0);

  const showMask = !!readingMask && (!editMode || toggleState === 'after');

  const height = useMemo(() => {
    if (mouseY > 0) {
      return `calc(100vh - ${mouseY}px - ${LINE_SIZE_PX / 2}px)`;
    }

    return 0;
  }, [mouseY]);

  useEffect(() => {
    if (!readingMask) {
      return;
    }

    const handleMouseMove = (event: MouseEvent) => setMouseY(event.clientY);

    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, [readingMask]);

  return (
    showMask && (
      <Portal>
        <Overlay
          style={{ height: `calc(${mouseY}px - ${LINE_SIZE_PX / 2}px)` }}
        />
        <Overlay style={{ top: 'auto', bottom: 0, height }} />
      </Portal>
    )
  );
}

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 0;
  pointer-events: none;
  background-color: rgba(17, 17, 17, 0.3);
  z-index: 1000000;
`;
